(() => {
  const newUserRegistrationCheckBox = '.new-event-reservation-user-registration-check-box'
  const newPasswordForm = '.event_reservation_new_password_form'
  const password = '.event-registration-password'
  const passwordConfirmation = '.event-registration-password-confirmation'
  const adultNum = '.event-adult-num';
  const kidsNum = '.event-kids-num';
  const eventTos = '.event-tos_acceptance';
  const name = '.event-person-name';
  const nameKana = '.event-person-name-kana';
  const phoneNumber = '.event-person-phone-number';
  const email = '.event-person-email';
  const showDisabledBtn = '.show-disabled-button'
  const showActiveBtn = '.show-active-button'

  const init = () => {
    if (location.href.indexOf('customer/event/event_reservation') < 1 ) {
      return
    }
    $(showDisabledBtn).show()
    $(showActiveBtn).hide()

    $('body')
      .on('change', adultNum, checkValidValue)
      .on('change', kidsNum, checkValidValue)
      .on('change', eventTos, checkValidValue)
      .on('change', name, checkValidValue)
      .on('change', nameKana, checkValidValue)
      .on('change', phoneNumber, checkValidValue)
      .on('change', email, checkValidValue)
      .on('click', newUserRegistrationCheckBox, toggleNewPasswordForm);

    $(newPasswordForm).hide();
    toggleNewPasswordForm();
    checkValidValue();

    $('#event-login-confirmation-modal').click();
  }

  const toggleNewPasswordForm = () => {
    if ($(newUserRegistrationCheckBox).prop('checked')) {
      $(password).prop('disabled', false);
      $(passwordConfirmation).prop('disabled', false);
      $(newPasswordForm).fadeIn();
    } else {
      $(password).prop('disabled', true);
      $(passwordConfirmation).prop('disabled', true);
      $(newPasswordForm).fadeOut();
    }
  }
  const checkValidValue = () => {
    if (($(adultNum).val() > 0 || $(kidsNum).val() > 0) && $(eventTos).prop('checked') && $(name).val() !== '' && $(nameKana).val() !== '' && $(phoneNumber).val() !== '' && $(email).val() !== '') {
      $(showDisabledBtn).hide()
      $(showActiveBtn).show()
    }      
    else {
      $(showDisabledBtn).show()
      $(showActiveBtn).hide()
    }
  }


  $(init);
})();


